import React, { Fragment } from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { NavLink } from 'react-router-dom';
import { Tab } from '@headlessui/react';
import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import MainContent from '../MainContent';
import RightBar from '../RightBar';
import Calendar from '../calendar/Calendar';

// Shared shell for the analytics report pages: header card with breadcrumb,
// title and description, then either tabbed reports or plain children.
function AnalyticsPageLayout({ title, description, tabs, children }) {
  return (
    <>
      <MainContent>
        <div className="space-y-5 pb-6">
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm px-5 py-4">
            <Breadcrumbs
              aria-label="breadcrumb"
              separator={<NavigateNextIcon fontSize="small" />}
            >
              <NavLink to="/" className="flex items-center text-gray-500">
                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                <span className="text-xs">Home</span>
              </NavLink>
              <NavLink to="/analytics" className="text-gray-500">
                <span className="text-xs">Analytics</span>
              </NavLink>
              <span className="text-xs text-gray-900">{title}</span>
            </Breadcrumbs>
            <h1 className="text-lg font-semibold text-gray-900 mt-1">
              {title}
            </h1>
            {description && (
              <p className="text-xs text-gray-500">{description}</p>
            )}
          </div>

          {tabs ? (
            <Tab.Group>
              <Tab.List className="flex flex-wrap gap-1 bg-white rounded-xl border border-gray-200 shadow-sm p-1">
                {tabs.map((tab) => (
                  <Tab as={Fragment} key={tab.title}>
                    {({ selected }) => (
                      <button
                        type="button"
                        className={`px-4 py-2 rounded-lg text-sm transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-claret-500 ${
                          selected
                            ? 'bg-[#FBEFF3] text-claret-500 font-semibold'
                            : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                        }`}
                      >
                        {tab.title}
                      </button>
                    )}
                  </Tab>
                ))}
              </Tab.List>
              <Tab.Panels>
                {tabs.map((tab) => (
                  <Tab.Panel key={tab.title} className="focus:outline-none">
                    {tab.component}
                  </Tab.Panel>
                ))}
              </Tab.Panels>
            </Tab.Group>
          ) : (
            children
          )}
        </div>
      </MainContent>
      <RightBar>
        <Calendar />
      </RightBar>
    </>
  );
}

export default AnalyticsPageLayout;
